// extracted by mini-css-extract-plugin
module.exports = {"button":"loginButton_button__2SOhn","loginText":"loginButton_loginText__3NfvQ","logIn":"loginButton_logIn__2aQ44"};